import * as Yup from 'yup';
import { UserRoleList } from '../../../../utils/enum';

export const userSchema = {
  name: Yup.string()
    .min(2, '최소 2자리이상 입력해주세요.')
    .max(30, '최대 30자리입니다.')
    .required('필수 입력값입니다.'),
  email: Yup.string()
    .email('이메일이 올바르지 않습니다.')
    .min(7, '이메일은 7자 이상입니다.')
    .max(100, '이메일은 100자 이하입니다.')
    .required('필수 입력값입니다.'),
  phone: Yup.string()
    .max(20, '연락처는 20자 이하입니다.')
    .matches(/^\d+$/, '연락처는 -없이 숫자만 입력해주세요.'),
  administrativeRegion: Yup.string().max(100, '최대 100자리입니다.').nullable(),
};

export const defaultValue = {
  administrativeRegion: '',
  createdAt: '',
  departmentId: undefined,
  email: '',
  name: '',
  phone: '',
  role: UserRoleList.USER,
  userId: '',
};
